import Swiper from 'swiper'
import { Navigation, Pagination, Mousewheel } from 'swiper/modules'
import { mousewheel } from '@/scripts/core/global'

export default class BundleVideos {
	constructor() {
		this.handleSlider();
	}

	handleSlider() {
		const slider = document.querySelector('.pdp-tab__section .swiper') as HTMLElement;
		slider && new Swiper(slider, {
			modules: [Navigation, Pagination, Mousewheel],
			slidesPerView: 1.39,
			mousewheel,
			navigation: {
				prevEl: slider.querySelector(
					'.swiper-button-prev'
				) as HTMLButtonElement,
				nextEl: slider.querySelector(
					'.swiper-button-next'
				) as HTMLButtonElement,
			},
			pagination: {
				el: slider.querySelector('.swiper-pagination') as HTMLElement,
				clickable: true,
			},
			breakpoints: {
				990: {
					slidesPerView: 3,
				},
			},
		})
	}
}